const copyToClipboard = async (value, addToast) => {
  await navigator.clipboard.writeText(value)

  addToast?.("Copied to clipboard!", { appearance: "success" })
}

export default copyToClipboard
